export const USER_ROLE = 0;
export const RESELLER_ROLE = 1;
export const SELLER_ROLE = 2;
export const SUPER_RESELLER_ROLE = 3;

export function isResellerOrSuper(givenRole: number | null) {
    if (givenRole === RESELLER_ROLE || givenRole === SUPER_RESELLER_ROLE) return true
    return false
}